import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import ImgTitle1 from '../../assets/images/ensikolopedia/img-title-1.png';
import ImgTitle2 from '../../assets/images/ensikolopedia/img-title-2.png';
import AwalMulaHoaksDesktop from '../../assets/images/ensikolopedia/awal-mula-hoaks-desktop.png';
import AwalMulaHoaksMobile from '../../assets/images/ensikolopedia/awal-mula-hoaks-mobile.png';
import InformasiDesktop from '../../assets/images/ensikolopedia/informasi-desktop.png';
import InformasiMobile from '../../assets/images/ensikolopedia/informasi-mobile.png';
import Jenis1 from '../../assets/images/ensikolopedia/jenis-1.png';
import Jenis2 from '../../assets/images/ensikolopedia/jenis-2.png';
import Jenis3 from '../../assets/images/ensikolopedia/jenis-3.png';
import Jenis4 from '../../assets/images/ensikolopedia/jenis-4.png';
import Jenis5 from '../../assets/images/ensikolopedia/jenis-5.png';
import Jenis6 from '../../assets/images/ensikolopedia/jenis-6.png';
import Jenis7 from '../../assets/images/ensikolopedia/jenis-7.png';
import BtnTutup from '../../assets/images/ensikolopedia/btn-tutup.png';
import HoaxLeft from '../../assets/images/ensikolopedia/hoax-left.png';
import HoaxRight from '../../assets/images/ensikolopedia/hoax-right.png';
import Section2Left1 from '../../assets/images/ensikolopedia/section-2-left-1.png';
import Section2Left2 from '../../assets/images/ensikolopedia/section-2-left-2.png';
import Section2Right1 from '../../assets/images/ensikolopedia/section-2-right-1.png';
import Section3Right1 from '../../assets/images/ensikolopedia/section-3-right-1.png';
import Section3Right2 from '../../assets/images/ensikolopedia/section-3-right-2.png';
import Section3Right3 from '../../assets/images/ensikolopedia/section-3-right-3.png';
import Section3Left1 from '../../assets/images/ensikolopedia/section-3-left-1.png';
import Section4Left from '../../assets/images/ensikolopedia/section-4-left.png';
import Section4Right from '../../assets/images/ensikolopedia/section-4-right.png';

const Ensiklopedi = ({ closeAction }) => {
  return (
    <>
      <section className="bg-ensiklopedi">
        <Container fluid className="bg-ensiklopedi-title position-relative py-5">
          <Row>
            <Col md="12" className="mb-5">
              <div className="justify-content-center align-items-start text-center">
                <h1 className="section-head-content marko-one">
                  ENSIKLOPEDIA <br /> HOAKS
                </h1>
              </div>
            </Col>
          </Row>
          <img src={ImgTitle1} alt="" className="img-title-1 img-asset"/>
          <img src={ImgTitle2} alt="" className="img-title-2 img-asset" />
        </Container>
        
        <div className="position-relative">
          <Container fluid className="ensiklopedi-section front position-relative">
            <Row>
              <Col md="12" className="mt-5">
                <div className="justify-content-center align-self-center text-center">
                  <h3 className="montserrat text-white">APA ITU HOAKS?</h3>
                  <h6 className="montserrat text-white">
                    Pengertian hoaks secara umum menurut KBBI adalah:<br/>
                    <b>Berita bohong</b> atau <b>kabar palsu</b> yang tidak bersumber
                    seolah-olah dibuat benar adanya dan diverifikasi keberadaannya.
                  </h6>
                  <h6 className="montserrat text-white">
                    <b>
                      Facebook menduduki peringkat pertama platform penyebaran <br /> hoaks{' '}
                    </b>
                    seputar <b>Vaksin dan Covid-19 </b> paling tinggi di antara Twitter, Instagram, WhatsApp, dan aplikasi online lainnya.
                  </h6>
                </div>
                <div className="justify-content-center align-items-end text-center">
                  <p className="section-text-sumber">Sumber: MAFINDO (2021)</p>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="position-relative img-asset">
            <img src={HoaxLeft} alt="hoax-left" className="hoax-left" />
            <img src={HoaxRight} alt="hoax-right" className="hoax-right" />
          </div>
        </div>
        <div className="p-m-auto">
          <hr />
        </div>
        <div className="position-relative">
          <Container fluid className="ensiklopedi-section front position-relative">
            <Row>
              <Col md="12" className="mt-5 text-center">
                <h3 className="montserrat text-white">AWAL MULA HOAKS</h3>
                <img src={AwalMulaHoaksDesktop} alt="awal-mula-hoaks" className="img-fluid awal-mula-hoaks desktop"/>
                <img src={AwalMulaHoaksMobile} alt="awal-mula-hoaks" className="img-fluid awal-mula-hoaks mobile" />
                <div className="justify-content-center align-items-end text-center my-5">
                  <p className="section-text-sumber">Sumber: MAFINDO (2021)</p>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="position-relative img-asset">
            <img src={Section2Left1} alt="section-2-left-1" className="section-2-left-1" />
            <img src={Section2Left2} alt="section-2-left-2" className="section-2-left-2" />
            <img src={Section2Right1} alt="section-2-right-1" className="section-2-right-1" />
          </div>
        </div>
        <div className="p-m-auto">
          <hr />
        </div>
        <div className="position-relative">
          <Container fluid className="ensiklopedi-section front position-relative">
            <Row>
              <Col md="12">
                <div className="justify-content-start align-self-start">
                  <h3 className="montserrat text-white">
                    MENGENAL <br /> MISINFORMASI, DISINFORMASI, <br /> DAN MALINFORMASI
                  </h3>
                  <h6 className="montserrat text-white">
                    Misinformasi, disinformasi, dan malinformasi merupakan <b>tiga istilah <br /> yang memiliki sangkut paut dengan hoaks.</b>
                  </h6>
                  <h6 className="montserrat text-white">
                    UNESCO melalui publikasi resmi berjudul “Journalism, Fake News and Disinformation” pada 2018 membagi hoaks ke dalam 3 (tiga) kategori: misinformasi, disinformasi, dan malinformasi.
                  </h6>
                </div>
              </Col>
              <Col className=" justify-content-center align-self-center text-center">
                <img src={InformasiDesktop} alt="informasi" className="img-fluid informasi desktop" />
                <img src={InformasiMobile} alt="informasi" className="img-fluid informasi mobile" />
              </Col>
              <div className="justify-content-center align-items-end text-center my-5">
                <p className="section-text-sumber">Sumber: UNESCO (2018)</p>
              </div>
            </Row>
          </Container>
          <div className="position-relative img-asset">
            <img src={Section3Right1} alt="section-3-right-1" className="section-3-right-1" />
            <img src={Section3Right2} alt="section-3-right-2" className="section-3-right-2" />
            <img src={Section3Right3} alt="section-3-right-3" className="section-3-right-3" />
            <img src={Section3Left1} alt="section-3-left-1" className="section-3-left-1" />
          </div>
        </div>
        <div className="p-m-auto">
          <hr />
        </div>
        <div className="position-relative">
          <Container fluid className="ensiklopedi-section front position-relative">
            <Row>
              <Col md="12">
                <div className="justify-content-center align-items-start text-center">
                  <h3 className="montserrat text-white">
                    7 JENIS HOAKS DAN DISINFORMASI
                  </h3>
                  <h6 className="montserrat text-white">
                    Hasil pengolahan <b> Mapping Hoaks Covid-19 </b> di tahun <b>2020-2021</b> <br />
                    menunjukkan tipe mis/disinformasi <b>"konten yang menyesatkan" paling banyak disebar melalui platform Facebook. </b>
                  </h6>
                  <h6 className="montserrat text-white">
                    <b>Topik bencana kesehatan dan politik </b> merupakan <b>topik paling umum </b> <br />
                    yang sering <b>diangkat </b> penyebar <b>hoaks</b>.
                  </h6>
                  <h6 className="montserrat text-white">
                    Berdasarkan jenisnya, hoaks dan disinformasi dibagi ke dalam tujuh jenis, yakni:
                  </h6>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center align-items-start text-center">
              <Col lg="4" md="4" sm="6" xs="6">
                <img src={Jenis1} alt="jenis-1" className="img-fluid p-2"/>
              </Col>
              <Col lg="4" md="4" sm="6" xs="6">
                <img src={Jenis2} alt="jenis-2" className="img-fluid p-2" />
              </Col>
              <Col lg="4" md="4" sm="6" xs="6">
                <img src={Jenis3} alt="jenis-3" className="img-fluid p-2" />
              </Col>
              <Col lg="4" md="4" sm="6" xs="6">
                <img src={Jenis4} alt="jenis-4" className="img-fluid p-2" />
              </Col>
              <Col lg="4" md="4" sm="6" xs="6">
                <img src={Jenis5} alt="jenis-5" className="img-fluid p-2" />
              </Col>
              <Col lg="4" md="4" sm="6" xs="6">
                <img src={Jenis6} alt="jenis-6" className="img-fluid p-2" />
              </Col>
              <Col lg="4" md="4" sm="6" xs="6">
                <img src={Jenis7} alt="jenis-7" className="img-fluid p-2" />
              </Col>
            </Row>

            <div className="note justify-content-center align-items-end text-center mt-3">
              <span className="text-ensiklopedi-note">
                Note: Warna paling gelap menandaikan <br /> jumlah hoaks yang paling banyak beredar.
              </span>
            </div>
            <div className="justify-content-center align-items-end text-center py-5">
              <p className="section-text-sumber">Sumber: MAFINDO (2021)</p>
            </div>
            <Row>
              <Col className="text-center">
                <button onClick={closeAction} className="btn border-0 bg-transparent">
                  <img src={BtnTutup} alt="btn-tutup" className="w-75"/>
                </button>
              </Col>
            </Row>
          </Container>
          <div className="position-relative img-asset">
            <img src={Section4Left} alt="section-4-left" className="section-4-left" />
            <img src={Section4Right} alt="section-4-right" className="section-4-right" />
          </div>
        </div>
        <div className="bg-ensiklopedi-bottom"></div>
      </section>
    </>
  );
};

export default Ensiklopedi;
